export default {
    entityKey: 'defects',
    basePath: '/defects',
    titles: {
        singular: 'Defect',
        plural: 'Defects'
    }
}
